import React from 'react';
import { ApiHandler } from '@givelify/api';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { AppState } from 'store';

export const INTEGRATION_STATS_QUERY_KEY =
    ApiHandler.instance.donees.getIntegrationStats.name;

export const useIntegrationStats = (enabled = true) => {
    const { donorId } = useSelector((state: AppState) => ({
        donorId: state.User.user.doneeId,
    }));
    const query = useQuery({
        queryKey: [INTEGRATION_STATS_QUERY_KEY, donorId],
        queryFn: async () => {
            const response =
                await ApiHandler.instance.donees.getIntegrationStats(donorId);
            return response;
        },
        enabled: enabled && !!donorId,
    });

    const integrationStats = React.useMemo(() => {
        if (query.data && query.data.success) {
            return query.data.response.data;
        }
        return null;
    }, [query.data]);

    const errorMessage = React.useMemo(() => {
        if (query.data && !query.data.success) {
            return query.data.error.message;
        }
        return '';
    }, [query.data]);

    return { ...query, integrationStats, errorMessage };
};
